import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-vendor-blocked',
  templateUrl: './vendor-blocked.component.html',
  styleUrls: ['./vendor-blocked.component.css']
})
export class VendorBlockedComponent implements OnInit {

 
  cid:any
  vendorList:any = []
  sigleVendorData:any = []
  note:any = ""

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  isLoading = false
  first: number = 0;

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllVendorByStatus(this.pageNumber,this.recordsPerPage)
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.getAllVendorByStatus(this.pageNumber,this.recordsPerPage)
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
  }

  getAllVendorByStatus(pageNumber:any,recordsPerPage:any){
    this.isLoading = true

    this.generic_service.getAllVendorByStatus('BLOCKED',pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response)
        this.vendorList = response.response.vendorMasterList;
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false

      }
    )
  }

  getVendorById(vendorMasterId:any){
    this.generic_service.getVendorById(vendorMasterId).subscribe(
      (response:any)=>{
        console.log(response)
        this.sigleVendorData = []
        this.sigleVendorData.push(response.response)
      }
    )
  }

  rejectVendor(){
    let body = {
      "userId": sessionStorage.getItem("userId"),
      "vendorMasterStatus": "REJECTED",
      "updatedDate": new Date().getTime(),
      "note": this.note
    }
    console.log(body)
  
    this.generic_service.updateVendorStatus(this.sigleVendorData[0].vendorMasterId,body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllVendorByStatus(this.pageNumber-1,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  approveVendor(){
    let body = {
      "userId": sessionStorage.getItem("userId"),
      "vendorMasterStatus": "APPROVED",
      "updatedDate": new Date().getTime(),
      "note": ""
    }
    console.log(body)
  
    this.generic_service.updateVendorStatus(this.sigleVendorData[0].vendorMasterId,body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllVendorByStatus(this.pageNumber-1,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }


  searchKey: any = ""

  getVendorMasterBySearchAndStatus(pageNumber: any,recordsPerPage: any){
    console.log(this.searchKey)
    if(this.searchKey != ""){
      this.isLoading = true

      this.generic_service.getVendorMasterBySearchAndStatus(this.searchKey,'BLOCKED',pageNumber,recordsPerPage).subscribe(
        (response:any)=>{
          console.log(response);
          this.vendorList = response.response.vendorMasterList;
          this.totalRecords = response.response.totalRecords;
          this.isLoading = false

        },
        (err:any)=>{
          console.log(err)
        }
      )
    }else{
      this.getAllVendorByStatus(this.pageNumber,this.recordsPerPage)
    }
  }

  refreshSearch(){
    this.searchKey = ""
    this.getAllVendorByStatus(this.pageNumber,this.recordsPerPage)
  }

}
